export const images = [
  './assets/utils/message-sign.png',
  './assets/utils/call-sign.png',
];
